import { RootStateOrAny } from 'react-redux'
import { Dispatch } from 'redux'

import { basketCheckedOut, basketCheckoutClicked, basketProceedToCheckout } from 'actions/basket'
import { boxSummaryVisibilityChange } from 'actions/boxSummary'
import { orderUpdate } from 'actions/order'
import { getIsAuthenticated } from 'selectors/auth'
import { isBasketTransactionalOrder } from 'selectors/basket'

import { RemoveRecipeFn } from '../domains/basket'
import { Pricing } from '../domains/pricing'
import { checkoutTransactionalOrder } from './checkoutTransactionalOrder'

type CheckoutBasketArgs = {
  section: string
  view: string
  pricing: Pricing | null | undefined
  removeRecipe: RemoveRecipeFn
}

export const checkoutBasket =
  ({ section, view, pricing, removeRecipe }: CheckoutBasketArgs) =>
  async (dispatch: Dispatch<any>, getState: () => RootStateOrAny) => {
    const state = getState()
    const isAuthenticated = getIsAuthenticated(state)
    const isTransactionalOrder = isBasketTransactionalOrder(state)
    const transactionalOrderForNonLoggedInUser = isTransactionalOrder && !isAuthenticated

    dispatch(boxSummaryVisibilityChange(false, removeRecipe))
    dispatch(basketCheckedOut({ view, pricing }))
    dispatch(basketCheckoutClicked(section))

    if (transactionalOrderForNonLoggedInUser) {
      dispatch(basketProceedToCheckout())

      return
    }

    if (isTransactionalOrder) {
      dispatch(checkoutTransactionalOrder())

      return
    }

    dispatch(orderUpdate())
  }
